<h1 mat-dialog-title>Autopłatność skonfigurowana</h1>
<mat-dialog-content>
  <div>
    Opłata {{ data.liability.title }} od dostawcy {{ data.liability.billerName }} zostanie opłacona automatycznie
    <span class="nowrap">{{
      data.liability.automaticPayment?.automaticPaymentScheduledDate | date: defaultPattern
    }}</span>
    przy pomocy karty <span class="nowrap">{{ getFullDescription(data.card) }}.</span><br />
    O obciążeniu karty poinformujemy Cię mailowo i przez SMS.
  </div>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <button mat-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
